import styled from 'styled-components'

export const PageLayout = styled.div`
    display: flex;
    gap: 24px;
    align-items: flex-start;
    width: 100%;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`

export const ErrorBox = styled.div`
    margin-bottom: 16px;
    background: #fff;
    border-left: 5px solid #d9534f;
    color: #b02a37;
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`

export const StateBox = styled.div`
    background: white;
    border-radius: 14px;
    padding: 18px;
    color: #2f4c7d;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`
